// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__9Dnkv","itemTitle":"ClientEmergencyInfo_itemTitle__1tY-2","itemText":"ClientEmergencyInfo_itemText__1FMfz"};